export default __webpack_public_path__ + "static/media/688.a712180b.gif";